<script setup lang="ts">
import { computed } from "vue"
import { FormFieldSet, FormLegend, FormDescription, FormGroup } from "@hantera/design-system"
import type { LayoutSet } from "./settings-layout"

const props = defineProps<{
  set: LayoutSet
}>()

function resolveTranslation(
  dict: Record<string, string> | undefined
): string | undefined {
  if (!dict) return undefined
  const userLang = document.documentElement.lang || "en"
  return dict[userLang] ?? dict["default"] ?? Object.values(dict)[0]
}

const legend = computed(() => resolveTranslation(props.set.label))
const description = computed(() => resolveTranslation(props.set.description))
</script>

<template>
  <FormFieldSet>
    <FormLegend v-if="legend">{{ legend }}</FormLegend>
    <FormDescription v-if="description">{{ description }}</FormDescription>
    <FormGroup>
      <slot />
    </FormGroup>
  </FormFieldSet>
</template>
